import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ADMIN_PATHS, adminPath, adminUserPath } from '../../constants/adminPaths';
import { adminGetCompany } from '../../api/packagesApi';
import CompanyProfileContent from '../components/CompanyProfileContent';
import { PageSkeleton } from '../../../components/loading/skeletons';

import '../../styles/pages/users.css';

export default function AdminCompanyProfile() {
  const { companyId } = useParams();
  const navigate = useNavigate();

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      setError('');
      setLoading(true);
      try {
        const data = await adminGetCompany(companyId);
        if (!data) {
          setError('Company not found.');
          setCompany(null);
          return;
        }
        setCompany(data);
      } catch (e) {
        console.error(e);
        setError('Failed to load company.');
      } finally {
        setLoading(false);
      }
    })();
  }, [companyId]);

  if (loading) {
    return (
      <div className="admin-page" style={{ padding: 24 }}>
        <PageSkeleton variant="form" label="Loading company" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-page" style={{ padding: 24 }}>
        <div className="admin-card" style={{ padding: 16 }}>
          <div style={{ color: '#b91c1c' }}>{error}</div>
          <div style={{ marginTop: 12 }}>
            <button type="button" className="at-btn" onClick={() => navigate(adminPath(ADMIN_PATHS.USERS))}>
              Back to Users
            </button>
          </div>
        </div>
      </div>
    );
  }

  const ownerId = company?.ownerId || company?.createdBy || null;

  return (
    <div className="admin-page" style={{ padding: 24 }}>
      <div className="admin-card" style={{ padding: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800 }}>{company?.name || 'Company'}</div>
            <div style={{ marginTop: 6, fontSize: 12.5, color: 'rgba(15,23,42,0.72)' }}>
              Company ID: {company?.id}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {ownerId ? (
              <button type="button" className="at-btn" onClick={() => navigate(adminUserPath(ownerId))}>
                Open Owner User
              </button>
            ) : null}
            <button type="button" className="at-btn" onClick={() => navigate(adminPath(ADMIN_PATHS.USERS))}>
              Back to Users
            </button>
          </div>
        </div>

        <CompanyProfileContent
          company={company}
          onCompanyUpdated={setCompany}
          showCompanyId={false}
          showHeader={false}
        />
      </div>
    </div>
  );
}
